import { Component, OnInit, Input } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { DynamicFormInputTypes } from '../../models/dynamic-form-input-types';
import { CommonModule } from '@angular/common';
import { SsnInputComponent } from '../ssn-input/ssn-input.component';
import { TextInputComponent } from '../text-input/text-input.component';
import { TimeInputComponent } from '../time-input/time-input.component';
import { SelectInputComponent } from '../select-input/select-input.component';
import { CheckboxInputComponent } from '../checkbox-input/checkbox-input.component';
import { DateInputComponent } from '../date-input/date-input.component';
import { NumberInputComponent } from '../number-input/number-input.component';
import { CurrencyInputComponent } from '../currency-input/currency-input.component';
import { TextAreaInputComponent } from '../text-area-input/text-area-input.component';
import { EmailInputComponent } from '../email-input/email-input.component';
import { PasswordInputComponent } from '../password-input/password-input.component';
import { ToggleInputComponent } from '../toggle-input/toggle-input.component';
import { RadioInputComponent } from '../radio-input/radio-input.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'; 

@Component({
  selector: 'app-generic-input',
  templateUrl: './generic-input.component.html',
  styleUrls: ['./generic-input.component.css'],
  imports: [
    CommonModule,
    SsnInputComponent,
    TextInputComponent,
    TimeInputComponent,
    SelectInputComponent,
    CheckboxInputComponent,
    DateInputComponent,
    NumberInputComponent,
    CurrencyInputComponent,
    TextAreaInputComponent,
    EmailInputComponent,
    PasswordInputComponent,
    ToggleInputComponent,
    RadioInputComponent,
    ReactiveFormsModule, FormsModule,  
  ],
})

export class GenericInputComponent extends BaseInputDirective implements OnInit {
  @Input() readonly: boolean;
  @Input() employeeId: number;
  @Input() showViewSSNButton: boolean = false;
  @Input() hasSSN: boolean = false;
  @Input() placeholder: string;
  @Input() showCharacterCount: boolean = false;

  textType = DynamicFormInputTypes.text;
  dateType = DynamicFormInputTypes.date;
  numberType = DynamicFormInputTypes.number;
  checkboxType = DynamicFormInputTypes.checkbox;
  selectType = DynamicFormInputTypes.select;
  currencyType = DynamicFormInputTypes.currency;
  textAreaType = DynamicFormInputTypes.textArea;
  emailType = DynamicFormInputTypes.email;
  passwordType = DynamicFormInputTypes.password;
  toggleType = DynamicFormInputTypes.toggle;
  radioType = DynamicFormInputTypes.radio;

  
 



  ngOnInit() {
    super.ngOnInit();
  }

  onChanged(event: any) {
    this.change.emit(event);
  }
}
